module.exports = __webpack_public_path__ + "img/diesel-locomotive-08.1dd3dbda.png";